import { Buffer } from 'buffer'

export const encodeToBase64 = (str: string): string => Buffer.from(str).toString('base64')
export const decodeFromBase64 = (str: string): string => Buffer.from(str, 'base64').toString()
